export default {"src":"/_next/static/media/sob-own.34d47042.svg","height":100,"width":100};